import { colors } from "melodies-source/Theme";

export type DataPoint = {
  label: string;
  value: number;
};

export const chartColors = [
  colors.navy,
  "#493391",
  "#7666ad",
  colors.navy40,
  colors.navy20,
  colors.navy10,
  colors.green60,
  colors.green,
  colors.yellow60,
  colors.yellow,
  colors.blue,
  colors.blue40,
  colors.red60,
  colors.red,
];
